<div class="relative z-30">
  <div
    class="fixed inset-0 bg-black/60"
    aria-hidden="true"
  ></div>
  <div class="fixed inset-0 z-30 w-screen overflow-y-auto">
    <div class="h-full sm:p-5 flex justify-center items-center">
      <div
        class="sm:rounded-lg bg-[var(--faculty-50,platform-50)] h-full w-full sm:max-h-[800px] sm:w-full sm:max-w-5xl py-4 sm:p-6 shadow-xl transform transition-all"
      >
        <ng-content />
      </div>
    </div>
  </div>
</div>
